<div class="claim-detail-sec" [ngClass]="{'ma-claim-detail-sec': !isAcmic}">
  <div class="claim-item">
    <div class="claim-number">
      <ng-container
        *ngIf="claim?.propertyOrAutoIndicator === 'AUTO'; else homeLogo"
      >
        <ng-container *ngIf="isAcmic; else maCarIcon">
          <img src="./assets/img/images/icon-car-24.svg" alt="car icon" />
        </ng-container>
        <ng-template #maCarIcon>
          <img src="./assets/img/images/icon-car.svg" alt="car icon" />
        </ng-template>          
      </ng-container>
      <ng-template #homeLogo>
        <ng-container *ngIf="isAcmic; else maHomeIcon">
          <ng-container  *ngIf="claim?.propertyOrAutoIndicator === 'UMBRELLA'; else acmicHomeIcon" >
            <img src="./assets/img/images/icon-umbrella-acmic.svg" alt="umbrella icon" />
          </ng-container>
          <ng-template #acmicHomeIcon>
            <img src="./assets/img/images/icon-home-24.svg" alt="home icon" />
          </ng-template>
        </ng-container>
        
        <ng-template #maHomeIcon>
          <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'HOME'; else otherPolicyIcon">

            <img src="./assets/img/images/icon-home.svg" alt="home icon" />
          </ng-container>
          <ng-template #otherPolicyIcon>
            <div class="{{ claim?.propertyOrAutoIndicator | lowercase }}-class paperless-bg margin-right mr8 width-40 height-40"
              *ngIf="claim?.propertyOrAutoIndicator!=='AUTO' && claim?.propertyOrAutoIndicator !== 'HOME' "></div>
          </ng-template>
        </ng-template>         
      </ng-template>
      <div class="claims-font" [ngClass]="{ 'ml-0': isAcmic }">{{ claimid }}</div>
    </div>
    <div class="claim-info" [ngClass]="{'margin-left ml16 no-margin-top': !isAcmic}">
      <div class="claim-info-left">
        <div>{{ claim?.lossCause }}</div>
        <div class="policy-id margin-bottom mb4 claim-infor-color">
          <ng-container>
              <ng-container *ngIf="claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' || claim?.propertyOrAutoIndicator === 'HOME'">Personal</ng-container>
              {{claim?.propertyOrAutoIndicator === 'AUTO' || claim?.propertyOrAutoIndicator === 'COMMERCIAL_AUTO' || claim?.propertyOrAutoIndicator === 'GARAGE_KEEPER' ? 'auto' : claim?.propertyOrAutoIndicator === 'HOME' ? 'property' : claim?.propertyOrAutoIndicator | translate | titlecase }} - {{ claim?.policyNumber?.policyNumber }}
            </ng-container>
        </div>
        <div class="date-loss">
          <span> {{ "Date of loss" | translate }}</span>
          {{ claim?.date | date: "MM/dd/yyyy" }}
        </div>
      </div>
    </div>
  </div>
  <app-cliams-nav [claimId]="claimid"></app-cliams-nav>
</div>
<div class="claim-detail-exposures claim-detail-sections">
  <section class="claim-details-left" [ngClass]="company === 'TW' ? 'claim-detail-tw': null">
    <ng-container
      *ngIf="claim?.exposures?.length === 1 && (claim?.exposures[0].displayToInsured === 'N' || claim?.exposures[0].displayToInsured === ''); else exposureWithDisplayToInsuredNotN">
      <div class="exposures-content no-exposures">
        <div class="exposures-title mb-3">
          {{ 'Information' | translate }}
        </div>
        <div class="no-exposures-info">
          <div class="claim-location mb-3">
            <div class="claim-info-label">
              {{'Location'}}
            </div>
            <div class="claim-info-value">
              <span *ngIf="claim?.exposures[0]?.address?.streetName !== ''">
                {{ claim?.exposures[0]?.address?.streetName | titlecase }},
              </span>
              <ng-container *ngIf="claim?.exposures[0]?.address?.city">
                {{ claim?.exposures[0]?.address?.city | titlecase }},
              </ng-container>
              {{ claim?.exposures[0]?.address?.state }}
            </div>
          </div>
          <div class="claim-desc mb-3">
            <div class="claim-info-label">
              {{'Description'}}
            </div>
            <div class="claim-info-value">
              {{claim?.lossCause}}
            </div>
          </div>
          <div class="claim-adjuster" *ngIf="claim?.exposures[0]?.adjuster">
            <div class="claim-info-label mb-1">
              {{'Adjuster'}}
            </div>
            <div class="adjuster-details">
              <div class="claim-info-value mb-2">
                {{claim?.exposures[0]?.adjuster?.name | titlecase}}
              </div>
              <div class="claim-info-value mb-2" *ngIf="!isAcmic">
                <div class="adjuster-infor">
                  <div class="adjuster-info-title">{{ 'EMAIL' | translate }}:</div>
                  <div class="adjuster-info-val"><a href="mailto:{{claim?.exposures[0]?.adjuster?.email?.address}}"
                    class="mapfre link underline red-link">{{ claim?.exposures[0]?.adjuster?.email?.address | lowercase }}</a>
                  </div>
                </div>
              </div>
              <div class="claim-info-value mb-2">
                <div class="adjuster-infor">
                  <div class="adjuster-info-title">{{ 'PHONE' | translate }}:</div> 
                  <div class="adjuster-info-val">
                    <a
                    href="tel:{{claim?.exposures[0]?.adjuster?.phoneNumber?.number | viewableExtension }}"
                    class="mapfre link underline red-link">{{claim?.exposures[0]?.adjuster?.phoneNumber?.number | viewableExtension }}</a>
                  </div>
                </div>
              </div>
              <div class="claim-info-value" *ngIf="claim?.exposures[0]?.adjuster?.extensionAndFax && !isAcmic">
                <div class="adjuster-infor">
                  <div class="adjuster-info-title">{{ 'FAX' | translate | titlecase }}:</div> 
                  <div class="adjuster-info-val"><a
                    href="tel:{{ claim?.exposures[0]?.adjuster?.extensionAndFax | usableFaxWithExtension }}"
                    class="mapfre link underline red-link">{{ claim?.exposures[0]?.adjuster?.extensionAndFax }}</a>
                  </div>
                </div>
              </div>
            </div>
    
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #exposureWithDisplayToInsuredNotN>    
    <div
      class="exposures-content mb-4"
      *ngIf="claim?.exposures?.length; else noExposures"
    >
      <div class="exposures-title">
        {{ "Incident" | translate }}
      </div>
      <div class="exposure-types mt-4">
        <ng-container *ngFor="let exposure of claim?.exposures">
          <div class="exposure-type-card" *ngIf="exposure.displayToInsured === 'Y' || exposure.displayToInsured === 'L'">
            <div class="exposure-card-title mb-3">
              {{ exposure?.coverage?.code }}
            </div>
            <div class="exposure-card-button w-100-mobile">
              <a [routerLink]="[
                      '/claims/exposures/' +
                        claimid +
                        '-' +
                        exposure?.exposureNumber?.exposureNumber +
                        '/details'
                    ]" class="claim-details-link w-100-mobile" mdbRipple>
                <span class="margin-right mr4">{{ "DETAILS" | translate }}</span>
                <ng-container *ngIf="isAcmic; else maClaimLink">
                  <svg-arror-right-svg></svg-arror-right-svg>
                </ng-container>
                <ng-template #maClaimLink>
                  <img src="./assets/img/images/icon-arrow-right-white.svg" alt="right arrow" />
                </ng-template> 
              </a>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-template #noExposures>
        <div class="exposures-content no-exposures">
            <div class="exposures-title mb-3">
               {{ 'Information' | translate }}
            </div>
            <div class="no-exposures-info">
              <div class="claim-location mb-3">
                <div class="claim-info-label">
                  {{'Location'}}
                </div>
                <div class="claim-info-value">
                    <span *ngIf="claim?.lossLocation?.addressLine1" >
                        {{ claim?.lossLocation?.addressLine1 | titlecase }},
                    </span>
                    <ng-container *ngIf="claim?.lossLocation?.city">
                      {{ claim?.lossLocation?.city | titlecase }}, 
                    </ng-container>
                       {{claim?.lossLocation?.state}}
                </div>
              </div>
              <div class="claim-desc mb-3">
                <div class="claim-info-label">
                    {{'Description'}}
                  </div>
                  <div class="claim-info-value">
                    {{claim?.lossCause}}
                  </div>
              </div>
              <div class="claim-adjuster" *ngIf="claim?.adjuster">
                  <div class="claim-info-label mb-1">
                      {{'Adjuster'}}
                  </div>
                  <div class="adjuster-details">
                      <div class="claim-info-value mb-2">
                          {{claim?.adjuster?.name | titlecase}}
                        </div>
                        <div class="claim-info-value mb-2" *ngIf="!isAcmic">
                            <div class="adjuster-infor">
                              <div class="adjuster-info-title">{{ 'EMAIL' | translate }}:</div>
                              <div class="adjuster-info-val"><a href="mailto:{{claim?.adjuster?.email?.address}}"
                                  class="mapfre link underline red-link">{{ claim?.adjuster?.email?.address | lowercase }}</a>
                              </div>
                            </div>
                        </div>
                        <div class="claim-info-value mb-2">
                            <div class="adjuster-infor">
                              <div class="adjuster-info-title"> {{ 'PHONE' | translate }}:</div> 
                              <div class="adjuster-info-val">
                                <a href="tel:{{claim?.adjuster?.phoneNumber?.number | viewableExtension }}"
                                  class="mapfre link underline red-link">{{claim?.adjuster?.phoneNumber?.number | viewableExtension }}</a>
                              </div>
                              </div>
                        </div>
                        <div class="claim-info-value" *ngIf="claim?.adjuster?.extensionAndFax && !isAcmic">
                            <div class="adjuster-infor">
                              <div class="adjuster-info-title">{{ 'FAX' | translate | titlecase }}: </div>
                              <div class="adjuster-info-val"><a href="tel:{{ claim?.adjuster?.extensionAndFax | usableFaxWithExtension }}"
                                  class="mapfre link underline red-link">{{ claim?.adjuster?.extensionAndFax }}</a>
                              </div>
                            </div>
                        </div>
                  </div>
                    
              </div>
            </div>
        </div>        
    </ng-template>
  </ng-template>
    
  </section>
  <section *ngIf="company !== 'TW'" class="claim-details-right">
    <div class="row claims-faq mb-4">
      <div class="col">
        <app-upload-documents-sidebar
          [claimId]="claimid"
        ></app-upload-documents-sidebar>
      </div>
    </div>
    <div class="row claims-faq mb-4" *ngIf="!isAcmic">
      <div class="col">
        <app-claims-need-help></app-claims-need-help>
      </div>
    </div>
  </section>
</div>
